import { Prisma, prisma } from "client";
export const getDiscountAdjustmentById = async (id: string) => {
  try {
    const DiscountAdjustment = await prisma.discountAdjustment.findFirst({
      where: {
        id: id,
      },
    });

    return DiscountAdjustment;
  } catch (error) {
    console.error("Error fetching discount adjustment by ID:", error);
    throw error;
  }
};
export const getDiscountAdjustment = async (
  eventId: string,
  page: number = 1,
  pageSize: number = 10,
  search?: string
) => {
  try {
    const skip = (page - 1) * pageSize;
    const take = pageSize;
    let whereClause: Prisma.DiscountAdjustmentWhereInput = {};

    if (search) {
    }
    return (
      await prisma.discountAdjustment.findMany({
        where: whereClause,
        orderBy: {
          id: "desc",
        },
        skip: skip,
        take: take,
      }),
      prisma.discountAdjustment.count({
        where: whereClause,
      })
    );
  } catch (error) {
    console.error("Error fetching discount adjustment:", error);
    throw error;
  }
};
export const createDiscountAdjustment = async (
  data: Prisma.DiscountAdjustmentCreateInput,
  eventId: string,
  adjustmentRuleId: string
) => {
  try {
    return await prisma.discountAdjustment.create({
      data: {
        ...data,
        event: {
          connect: {
            id: eventId,
          },
        },
        adjustmentRule: {
          connect: {
            id: adjustmentRuleId,
          },
        },
      },
    });
  } catch (error) {
    console.error("Error creating discount adjustment:", error);
    throw error;
  }
};
export const updateDiscountAdjustment = async (
  id: string,
  data: Prisma.DiscountAdjustmentUpdateInput
) => {
  try {
    return await prisma.discountAdjustment.update({ where: { id }, data });
  } catch (error) {
    console.error("Error updating discount adjustment:", error);
    throw error;
  }
};
